import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {


  constructor(private router: Router) {
    // Abre menu fullscreen en mobile
    $(document).ready(function() {
      $('.nav-link').on('click', function() {
        $('.navbar-collapse').removeClass('show');
      });
    });
  }

  ngOnInit() {
    // Posiciona nueva pagina cargada en top 0
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

}




// WEBPACK FOOTER //
// ./src/app/shared/header/header.component.ts